<template>
<div class=""  style="padding:0 20px;">

   <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="180px" class="label-30">

  <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI NETWORK VON</div>

   <div class="row pad" style="margin-top:20px;">
      <div class="col s12">
      <el-form-item label="Ultimo anno pagato" prop="vonyear">
        <el-select v-model="item.row.vonyear"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Sconosciuto" value="-7" ></el-option>
          <el-option label="Anno 2019" value="2019" ></el-option>
          <el-option label="Anno 2020" value="2020" ></el-option>
          <el-option label="Anno 2021" value="2021" ></el-option>
          <el-option label="Anno 2022" value="2022" ></el-option>
          <el-option label="Anno 2023" value="2023" ></el-option>
          <el-option label="Anno 2024" value="2024" ></el-option>
          <el-option label="Anno 2025" value="2025" ></el-option>
          <el-option label="Anno 2026" value="2026" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12">
      <el-form-item label="Data di pagamento" prop="vonpayment" class="is-required">
        <el-date-picker v-model="item.row.vonpayment" type="date" placeholder="Indica la data" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div> 

      <div class="col s12" >
      <el-form-item label="Note" prop="vonnote">
        <el-input  type="textarea" :rows="4" v-model="item.row.vonnote"></el-input>
      </el-form-item>
      </div>
<!--
      <div class="col s12">
      <el-form-item label="Ultimo paziente inserito" prop="lastvonnumber">
        <el-input  v-model="item.row.lastvonnumber"></el-input>
      </el-form-item>
      </div> 
-->

   </div>









    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Annulla</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" v-if="$centro.profile.rowIsNew">Registrati</el-button>
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" v-else>Salva</el-button>
      </div>
    </div>


    </el-form>

</div>
</template>

<script>
import dbItem from '../teras/dbItem'
export default {
  name: 'centro-von',
  components: {

  },
  data() {
    return {
         loading:{}
         ,item:{}
      }
  },
   created () {
      console.log("Arrivo al centro-von.vue con id "+this.$route.params.id)
      this.item = new dbItem({table:'centro'})

      this.item.load(this.$route.params.id).then((data) => {

         if(this.item.rowIsNew){
            this.$router.push('/centro-admin/')
         }else{
                
         if(this.item.row.vonpayment=='0000-00-00')
            this.item.row.vonpayment=''
         if(this.item.row.vonyear=='0')
            this.item.row.vonyear=''
         //mettere il nome della pagina cme modifica
         }
      })
   },
  beforeDestroy () {

  },
  methods: {
    onSubmit: async function() {
         this.$refs.formBasic.validate(async (valid) => {
         if (valid) {      
            this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
            
            await this.item.save()
            //await this.$centro.init()

            this.$teras.event.emit('centroLoad')

            this.loading.close()
            this.$router.push('/centro-admin/')
            
         } else {
            return false
         }
         })
      }
      ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/centro-admin/')
      }
  },
  computed: {
    rulesForm:function() {
      var rulesNow = {
        vonpayment: [
          { required: true, message: 'Il giorno di pagamento è obbligatorio', trigger: 'blur' }
        ]
        
        /*
        vonyear: [
          { required: true, message: 'L\'anno di adesione è obbligatorio', trigger: 'blur' }
        ],
        */

        
        
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;



}
</style>